import React, { memo, useState } from 'react';
import { Stack, Typography } from 'investira.react.components';
import { validators } from 'investira.sdk';
import { AVALIACAO_SESSOES_QUESTOES } from '../../../enums';
import QuestaoCardTipo from '../_components/QuestaoCardTipo';

const AvaliacoesGestorEditQuestoes = memo(props => {
  const { sessoes = {}, activeCategoryId, respostas = {}, onQuestionChange } = props;

  const [selectedIndex, setSelectedIndex] = useState(1);

  const handleListItemClick = (pEvent, pIndex) => {
    setSelectedIndex(pIndex);
  };

  if (validators.isEmpty(activeCategoryId)) {
    return null;
  }

  const xQuestoesCategoria = AVALIACAO_SESSOES_QUESTOES[activeCategoryId];

  return (
    <Stack gap={2}>
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="caption" color="textSecondary" sx={{ textTransform: 'uppercase' }}>
            Sessão {`${sessoes[activeCategoryId].sessao}`}
          </Typography>
        </Stack>
        <Typography variant="h5" color="textPrimary">
          {sessoes[activeCategoryId].label}
        </Typography>
      </Stack>
      <Stack gap={3} pt={2}>
        {xQuestoesCategoria &&
          xQuestoesCategoria?.questoes.map((xQuestao, xIndex) => {
            return (
              <QuestaoCardTipo
                key={crypto.randomUUID()}
                index={xIndex}
                data={xQuestao}
                value={respostas[xQuestao.id]?.resposta_id ?? ''}
                onChange={onQuestionChange}
              />
            );
          })}
      </Stack>
    </Stack>
  );
});

export default AvaliacoesGestorEditQuestoes;
